export const MONTHLY = "MONTHLY";
export const ANNUAL = "ANNUAL";
export const QUARTERLY = "QUARTERLY";
export const SEMI_ANNUAL = "SEMI_ANNUAL";
export const NOT_APPLICABLE = "NOT_APPLICABLE";
